import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import { translate } from "react-translate";

import {
  Segment,
  Image,
  Container,
  Header
} from 'semantic-ui-react';

import './landing.css'
import './firstcarousel.css'

import image_hotte from '../../../assets/tmp/Hotte_icon.png'
import image_mur from '../../../assets/tmp/Murs_icon.png'
import image_plantes from '../../../assets/tmp/Plantes_icon.png'
import image_reduction from '../../../assets/tmp/Reduction_icon.png'
import image_sols from '../../../assets/tmp/Sols_icon.png'

import picture1 from '../../../assets/img/landing1.png'
import picture2 from '../../../assets/img/landing2.png'
import picture3 from '../../../assets/img/landing3.png'
import picture4 from '../../../assets/img/landing5.png'
import picture5 from '../../../assets/img/landing5.png'

class CarouselComponent extends Component {


  render() {

    const owl = {
            0:{
                items: 1,
                loop:true
            },
            500:{
                items: 3,
                loop:true
            },
            1000:{
                items: 5,
                loop:true
            }
    }
    const { t } = this.props;

    var img = {
        display: 'block',
        width: '100%',
        height: 'auto',
    }
    return (

        <OwlCarousel
            className="owl-theme"
            loop
            items={1}
            dots={true}
            autoplay={true}
            autoplayTimeout={3000}
            autoplaySpeed={1000}
            autoplayHoverPause
            autoheight="true"
            id="firstCarousel">

            <div className="item" id="item-1"></div>
            <div className="item" id="item-2"></div>
            <div className="item" id="item-3"></div>
            <div className="item" id="item-4"></div>
            <div className="item" id="item-5"></div>

        </OwlCarousel>
    );
  }
}

export default translate("LandingComponent")(CarouselComponent);



// WEBPACK FOOTER //
// ./src/components/Public/LandingPage/LandingCarouselComponent.js